import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Client } from 'src/providers/client/client';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';

import { PlansPage } from 'src/pages/plans/plans';

import { Util } from 'src/shared/util/util';
import { BookService } from 'src/shared/services/book.service';

@Component({
  templateUrl: 'select-property.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class SelectPropertyPage implements OnInit {

  addressesResponse: any;
  propertyItems: any;
  form: UntypedFormGroup;

  
  boundGoToNextPage = this.goToNextPage.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    public windowService: WindowService,
    private bookService: BookService
  ) {
    this.form = this.fb.group({
      property: [''],
    });
  }

  async ngOnInit() {
    try {
      this.rightSidePanelService.setDialogPageTitle('Select Property');
      this.addressesResponse = await this.client.getAddresses();
      this.propertyItems = [];
      this.addressesResponse.map((address) => {
        this.propertyItems.push({
          viewValue: address.address_name ? address.address_name : address.address1,
          value: address.id
        });
      });
      const addressId = await this.client.getSelectedAddressId(this.addressesResponse);
      this.form.patchValue({ property: addressId });
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async goToNextPage() {
    localStorage.setItem('addressId', this.form.value.property);
    const address = this.addressesResponse.find(add => add.id === this.form.value.property);
    await this.bookService.goToBookJob({ address, bookingType: 'add_job' });
  }
  
}